import React, {useEffect, useState} from 'react';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {InvoicesGridContextProvider} from '../../components/InvoicesGridContext';
import InvoicesGrid from '../../components/InvoicesGrid';
import FieldCustomerID from '../../components/FieldCustomerID';
import FieldDateRange from '../../components/FieldDateRange';
import FieldStatus from "../../components/FieldStatus";
import FieldInvoice from '../../components/FieldInvoice';
import PageHeader from '../../../../common/components/ui/PageHeader';
import FiltersBar from '../../../../common/components/ui/FiltersBar';
import ButtonDownload from '../../components/ButtonDownload';
import StatsPanel from '../../components/StatsPanel';
import FooterDivider from "../../../../common/components/ui/FooterDivider";
import FooterLogo from "../../../../common/components/ui/FooterLogo";
import styles from './Ivoices.module.scss';
import ButtonShowHide from '../../components/ButtonShowHide';

const Invoices = () => {
  const {setPageTitle} = useGlobalContext();
  const {setPopupPanelContent, closePopupPanel} = useGlobalContext();
  const [show, setShow] = useState(true);

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'invoices-page-header'}
        defaultMessage={'Invoices'}
      />
    ));

    return () => {
      closePopupPanel();
      setPopupPanelContent(null);
    };
  }, []);

  return (
    <InvoicesGridContextProvider>
      <FiltersBar>
        <div className={styles.filtersContainer}>
          <FieldDateRange/>
          <FieldCustomerID/>
          <div className={styles.buttonDownloadDesktop}>
            <ButtonDownload/>
          </div>
          <FieldStatus/>
          <ButtonShowHide onClick={() => setShow(prevState => !prevState)} currentState={show}/>
          {show && <FieldInvoice/>}
        </div>
      </FiltersBar>
      <div className={styles.statsPanelContainer}>
        <StatsPanel/>
        <div className={styles.buttonDownloadMobile}>
          <ButtonDownload/>
        </div>
      </div>
      <InvoicesGrid/>
      <FooterDivider/>
      <FooterLogo/>
    </InvoicesGridContextProvider>
  );
};

export default Invoices;
